<a (click)="showMap = !showMap">{{showMap ? 'Hide' : 'Show'}} Map</a>

<span *ngIf="devOnlyMap && showMap" class="p-ml-3 p-text-italic">
	* Showing feature-limited map. LogBook domains show the fully featured one.
</span>

<p-gmap (onMapReady)="initializeMap($event)" [options]="mapOptions" [hidden]="!showMap" 
	styleClass="p-mt-3 map-container" [style]="{'height': '400px'}">
</p-gmap>